// @flow

const getPolygonPresenter = (props) => {
  const { type, features } = props;
  return {
    type,
    features,
  };
};

export default getPolygonPresenter;
